import enquiryForm from '../shared/enquiry-form';
import operatorInternalNotes from '../shared/operator-internal-notes';

export default {
  loaded() {
    enquiryForm()
    operatorInternalNotes()
  }
};
